import { render, staticRenderFns } from "./SearchInputCom.vue?vue&type=template&id=6f47531c&"
import script from "./SearchInputCom.vue?vue&type=script&lang=ts&"
export * from "./SearchInputCom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports